import React from 'react';

function TableButton(props) {
    let { text, color } = props;
    
    return (
        <div>
            <button {...props} type="button" style={{ backgroundColor: `${color}`}} className="cursor-pointer text-white rounded-full bg-purple-600 px-4 py-1 text-md">
                {text}
            </button>
        </div>
    );
}

export default TableButton;